type ContactRequestProps = {
  username: string;
  onAccept: () => void;
};

export function ContactRequest({ username, onAccept }: ContactRequestProps) {
  return (
    <div className="request-card">
      <span className="request-card__name">@{username}</span>
      <button type="button" onClick={onAccept}>
        принять
      </button>
    </div>
  );
}
